import * as React from "react";
const SvgFiRrHomeLocationAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-home-location-alt_svg__a)">
      <path
        fill="#062147"
        d="M24 9.724V19a5.006 5.006 0 0 1-5 5h-1a1 1 0 0 1 0-2h1a3 3 0 0 0 3-3V9.724a3 3 0 0 0-1.322-2.487l-7-4.723a2.98 2.98 0 0 0-3.356 0l-7 4.723A3 3 0 0 0 2 9.724V19a3 3 0 0 0 3 3h1a1 1 0 1 1 0 2H5a5.006 5.006 0 0 1-5-5V9.724a5 5 0 0 1 2.2-4.145l7-4.724a4.98 4.98 0 0 1 5.594 0l7 4.724A5 5 0 0 1 24 9.724m-5 5.283a6.95 6.95 0 0 1-2.05 4.949l-3.515 3.438a2.063 2.063 0 0 1-2.87 0l-3.507-3.43A7 7 0 1 1 19 15.007m-2 0a5 5 0 1 0-8.536 3.535l3.5 3.422 3.58-3.43A4.96 4.96 0 0 0 17 15.007M15 15a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-home-location-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHomeLocationAlt;
